module.exports = __webpack_public_path__ + "img/abstract-shapes-19.e726e470.svg";